import { render, staticRenderFns } from "./Masive.vue?vue&type=template&id=5130673c"
import script from "./Masive.vue?vue&type=script&lang=js"
export * from "./Masive.vue?vue&type=script&lang=js"
import style0 from "./Masive.vue?vue&type=style&index=0&id=5130673c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports